import { Text, View } from '@react-pdf/renderer';
import { BorderColor, TableStyle } from '../../../styles';
import LedgerTableFooter, {
  CashBookTableFooter,
  VoucherTableFooter,
} from './InvoiceTableFooter';
import InvoiceTableHeader, {
  CashBookTableHeader,
  TrialTableHeader,
  VoucherTableHeader,
} from './InvoiceTableHeader';
import InvoiceTableRow, {
  CashBookTableRow,
  TrialTableRow,
  VoucherTableRow,
} from './InvoiceTableRow';

const borderColor = BorderColor;

const styles = TableStyle;

function GetHeader(params) {
  console.log(params);

  switch (params.type) {
    case 'Ledger':
      return <InvoiceTableHeader />;
    case 'Voucher':
      return <VoucherTableHeader />;
    case 'Trial':
      return <TrialTableHeader />;
    case 'CashBook':
      return <CashBookTableHeader headerData={params.headerData} />;
    default:
      return <VoucherTableHeader />;
  }
}
function GetFooter(params) {
  switch (params.type) {
    case 'Ledger':
      return (
        <LedgerTableFooter
          codeDetails={params.codeDetails}
          totalDebit={params.totalDebit}
          totalCredit={params.totalCredit}
          balance={params.balance}
        />
      );
    case 'Voucher':
      return (
        <VoucherTableFooter
          totalDebit={params.totalDebit}
          totalCredit={params.totalCredit}
        />
      );
    case 'Trial':
      return <></>;
    case 'CashBook':
      return <CashBookTableFooter items={params} />;
    default:
      return (
        <VoucherTableFooter
          totalDebit={params.totalDebit}
          totalCredit={params.totalCredit}
        />
      );
  }
}

function GetRow(params) {
  console.log(params);
  switch (params.type) {
    case 'Ledger':
      return (
        <InvoiceTableRow
          items={params.invoice}
          openingBalance={params.openingBalance}
        />
      );
    case 'Voucher':
      return <VoucherTableRow items={params.invoice}></VoucherTableRow>;
    case 'Trial':
      return (
        <TrialTableRow
          items={params.invoice}
          level1Array={params.level1Array}
        />
      );
    case 'CashBook':
      return <CashBookTableRow items={params}></CashBookTableRow>;
    default:
      return <InvoiceTableHeader />;
  }
}

function OpeningBalanceRow(params) {
  return (
    <View style={styles.redRow} key={0}>
      <Text
        style={{
          width: '10%',
          borderRightColor: borderColor,
          borderRightWidth: 1,
        }}
      ></Text>
      <Text
        style={{
          width: '10%',
          borderRightColor: borderColor,
          borderRightWidth: 1,
        }}
      ></Text>
      <Text
        style={{
          width: '8%',
          borderRightColor: borderColor,
          borderRightWidth: 1,
        }}
      ></Text>

      <Text style={styles.particulars}>Opening Balance:</Text>
      <Text style={styles.balEmpN}>-</Text>
      <Text style={styles.balEmp}>-</Text>
      <Text style={styles.balEmp}>-</Text>
      <Text style={styles.bal}>{params.openingBalance}</Text>
    </View>
  );
}

const InvoiceItemsTable = ({
  invoice,
  totalDebit,
  totalCredit,
  balance,
  openingBalance,
  codeDetails,
  headerType,
  level1Array,
  headerData,
  level3Array
}) => {
  return (
    <View style={styles.tableContainer}>
      <GetHeader type={headerType} headerData={headerData} />
      {headerType == 'Ledger' ? (
        <OpeningBalanceRow openingBalance={openingBalance}></OpeningBalanceRow>
      ) : (
        <></>
      )}
      <GetRow
        type={headerType}
        invoice={invoice}
        level1Array={level1Array}
        openingBalance={openingBalance}
        headerData={headerData}
        level3Array={level3Array}
      ></GetRow>
      <GetFooter
        type={headerType}
        totalDebit={totalDebit}
        totalCredit={totalCredit}
        codeDetails={codeDetails}
        balance={balance}
        headerData={headerData}
      />
    </View>
  );
};

export default InvoiceItemsTable;
